export const removeHtmlTags = (str) => {
  if (typeof str === "string") {
    return { __html: str };
  }
  return "";
};

